import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        background: theme.palette.secondary.main,
        overflowY: "auto",
        flexGrow: 1,
    },
    titleContainer: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        color: theme.palette.info.main,
        padding: `${theme.spacing(2.5)} ${theme.spacing(6)} 0 ${theme.spacing(6)}`,
    },
    title: {
        fontSize: "11px !important",
    },
    optionsTitle: {
        fontSize: "14px !important",
        color: `${theme.palette.text.secondary} !important`,
        fontFamily: "Source Sans 3 !important",
        fontWeight: "400 !important",
        padding: theme.spacing(2),
    },
    caret: {
        fontSize: "16px !important",
        color: `${theme.palette.text.secondary} !important`,
        fontFamily: "Source Sans 3 !important",
        fontWeight: "400 !important",
    },
    button: {
        backgroundColor: "transparent",
        borderWidth: 0,
        padding: 0,
        fontFamily: "inherit",
        fontSize: "inherit",
        fontStyle: "inherit",
        fontWeight: "inherit",
        lineHeight: "inherit",
        cursor: "pointer",
    },
    listContainer: {
        display: "flex",
        flexDirection: "column",
        paddingLeft: 15,
    },
    areaListItemButton: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: "#FFFFFF",
        border: `1px solid ${theme.palette.border.select}`,
        borderRadius: "8px !important",
        marginBottom: theme.spacing(2),
        "&:hover": {
            backgroundColor: "#FAFAFA",
        },
    },
    functionalLocationItemsListItemButton: {
        paddingLeft: 0.5,
        display: "flex",
        flexDirection: "column",
    },
    addFunctionalLocationItemButton: {
        paddingLeft: 0.5,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start !important",
    },
    editIcon: {
        width: "min-content !important",
        height: "min-content !important",
        "& > svg": {
            fontSize: "16px !important",
        },
    },
    secondaryFunctionalLocationItemButton: {
        display: "flex",
        alignItems: "center",
    },
}));
